import axios from 'axios';
import { decodedJWT, getPasswordExpiryTimestamps, getPdbID } from './utils/commonUtils';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
});

// Add a request interceptor to inject the token
apiClient.interceptors.request.use(
    (config) => {
        if (!config.url?.includes("login") && !config.url?.includes("auth.tcn.com")) {
            const token = localStorage.getItem('token');
            const jwtToken = decodedJWT();
            if (config?.url !== "/api/v1/user/reset_password") {
                const { passwordExpiryDate } = getPasswordExpiryTimestamps(jwtToken);
                const currentDate = new Date();
                if (currentDate >= passwordExpiryDate) {
                    return Promise.reject(Error('Please refresh & reset password to resume normal services.'));
                }
            }
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            } else {
                // Redirect to login if token is undefined
                window.location.href = '/login'; // Adjust the path as necessary
                // You can also return a rejected promise to prevent the request from proceeding
                return Promise.reject(new Error('No token found'));
            }
            const pdbID = getPdbID(jwtToken);
            if (pdbID) {
                config.headers['X-PDB-ID'] = pdbID;
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default apiClient;
